// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDiskPen16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk-pen': IconFloppyDiskPen;
    }
}

/**
 * The icon component for the 'floppyDiskPen' icon
 */
export class IconFloppyDiskPen extends IconSvg {
    public constructor() {
        super(floppyDiskPen16X16);
    }
}

registerIconSvg('icon-floppy-disk-pen', IconFloppyDiskPen);
export const iconFloppyDiskPenTag = 'nimble-icon-floppy-disk-pen';
